import { render, staticRenderFns } from "./AmountCarsAvailable.vue?vue&type=template&id=61985b8f"
import script from "./AmountCarsAvailable.vue?vue&type=script&lang=js"
export * from "./AmountCarsAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports